module.exports = __webpack_public_path__ + "static/media/careerPeople.c6dbd017.jpg";